import { z } from "zod";

const AuditMaturitiesSchema = z.object({
  id: z.string().uuid({ message: "Id is required." }),
  scopeId: z.string().uuid({ message: "Scope is required." }),
  search: z.string(),
  page: z.number().min(1, { message: "Page is out of bounds" }),
  query: z.any(),
  sort: z.array(z.object({ property: z.string(), asc: z.boolean() })),
});

export default AuditMaturitiesSchema;
